import { Col, Container, Row } from "react-bootstrap";
import Title from "./Title";
import '../style/scss/advisorsBoard.scss';

const AdvisorsBoard = () => {
    const Advisors = [
        {avartar: require('../style/images/team/advisor-img-1.png'), name: 'Blocklabchain', job: 'Digital agency'},
        {avartar: require('../style/images/team/advisor-img-2.png'), name: 'Uber', job: 'VTC leader in the world'},
        {avartar: require('../style/images/team/advisor-img-3.png'), name: 'Osborne Clarke', job: 'International law firm'},
    ]
    return (
        <Container>
            <Title title={"Advisors Board"} />
            <Row className="advisors-board mt-5">
                {
                    Advisors.map((member, index) => {
                        return (
                            <Col lg={2} md={4} sm={4} xs={12} key={index} className="content">
                                <div className="profile">
                                    <img src={member.avartar} alt="" width="196" height="196" />
                                    <p className="name text-center">{member.name}</p>
                                    <p className="job text-center">{member.job}</p>
                                </div>
                            </Col>
                        )
                    })
                }
            </Row>
        </Container>
    )
}

export default AdvisorsBoard;